<nav class="top">
  <div class="top__lead">
    <!-- Opens the rail as a drawer below lg -->
    <button
      type="button"
      id="portal-menu-button"
      class="bk-icon-btn top__menu"
      (click)="handleMenuClick()"
      aria-controls="portal-rail"
      [attr.aria-expanded]="menuOpen"
      [attr.aria-label]="menuOpen ? 'Close menu' : 'Open menu'"
    >
      <span class="bk-sym" aria-hidden="true">menu</span>
    </button>

    <!-- On desktop the logo lives in the rail; here it only fills in for it -->
    <span class="top__logo">
      <img src="/images/BlackKonnectLogo_light.png" alt="Black Konnect" class="top__logo-img top__logo-img--on-dark" />
      <img src="/images/BlackKonnectLogo_dark.png" alt="Black Konnect" class="top__logo-img top__logo-img--on-light" />
    </span>

    <div class="top__crumbs">
      <app-breadcrumb></app-breadcrumb>
    </div>
  </div>

  <div class="top__actions">
    <button
      type="button"
      class="top__search"
      aria-haspopup="dialog"
      aria-label="Search pages, actions and messages"
      [attr.aria-keyshortcuts]="isApple ? 'Meta+K' : 'Control+K'"
      (click)="openSearch()"
    >
      <span class="bk-sym" aria-hidden="true">search</span>
      <span class="top__search-label" aria-hidden="true">Search</span>
      <span class="top__search-keys" aria-hidden="true">
        <kbd>{{ isApple ? "⌘" : "Ctrl" }}</kbd><kbd>K</kbd>
      </span>
    </button>
    <app-profile-avatar
      (optionsStateChange)="handleProfileOptionsChange($event)"
    />
  </div>
</nav>
